import type { LucideIcon } from 'lucide-react';
import { Blocks, Briefcase, CalendarDays, Gauge, GraduationCap, House, Landmark, Network, Package, Plug, Settings2, Users } from 'lucide-react';

/**
 * F5: sidebar gerada deste array. Só menus principais; os submenus são abas dentro da página (F6).
 * Um item aparece quando o usuário tem permissão e pelo menos um dos módulos do menu está instalado.
 */
export interface ItemMenu {
  chave: string;
  rota: string;
  icone: LucideIcon;
  modulos: string[]; // vazio = sempre visível
}

export const MENU: ItemMenu[] = [
  { chave: 'inicio', rota: '/', icone: House, modulos: [] },
  { chave: 'sala360', rota: '/sala360', icone: Gauge, modulos: ['sala360'] },
  { chave: 'cadastros', rota: '/cadastros', icone: Blocks, modulos: ['cadastros'] },
  { chave: 'comercial', rota: '/comercial', icone: Briefcase, modulos: ['pipeline', 'conversas'] },
  { chave: 'mutualforce', rota: '/mutualforce', icone: Network, modulos: ['mutualforce'] },
  { chave: 'financeiro', rota: '/financeiro', icone: Landmark, modulos: ['financeiro', 'contas'] },
  { chave: 'agenda', rota: '/agenda', icone: CalendarDays, modulos: ['agenda'] },
  { chave: 'pessoas', rota: '/pessoas', icone: Users, modulos: ['pessoas', 'folha'] },
  { chave: 'operacao', rota: '/operacao', icone: Package, modulos: ['estoque', 'compras'] },
  { chave: 'treinamento', rota: '/treinamento', icone: GraduationCap, modulos: ['treinamento'] },
  { chave: 'integracoes', rota: '/integracoes', icone: Plug, modulos: ['integracoes'] },
  { chave: 'admin', rota: '/admin', icone: Settings2, modulos: ['admin', 'configuracoes'] },
];

export function menuVisivel(instalados: readonly string[], permissoes: readonly string[]): ItemMenu[] {
  const tudo = permissoes.includes('*');
  return MENU.filter((m) => {
    if (m.modulos.length === 0) return true;
    return m.modulos.some((s) => instalados.includes(s) && (tudo || permissoes.some((p) => p.startsWith(`${s}.`))));
  });
}
